import React from "react";
import SignUpButton from "../SignUpButton/SignUpButton";

export default function BlurredTextCTA(props) {
    const loremIpsumParagraph =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

    return (
        <React.Fragment>
            <div className="container">
                <div className="blurredText">
                    <p>{loremIpsumParagraph}</p>
                    <p>{loremIpsumParagraph}</p>
                </div>
                <div className="overlay">
                    <p className="ctaText">
                        <span>Become A Member</span>
                        <br />
                        <span>To Unlock Full Details</span>
                    </p>
                    <SignUpButton />
                </div>
            </div>
            <style jsx>{`
                .container {
                    width: 100%;
                    position: relative;
                    margin-bottom: 4em;
                }
                .overlay {
                    display: grid;
                    place-items: center;
                    text-align: center;
                }
                .blurredText {
                    filter: blur(4px);
                    position: absolute;
                    top: 0;
                    width: 100%;
                }
                .ctaText {
                    font-size: 2em;
                    font-weight: bold;
                }
                p {
                    padding-bottom: 1em;
                }
            `}</style>
        </React.Fragment>
    );
}
